// src/hooks/useVerifiedAuth.js
import { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../services/firebase";

export function useVerifiedAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (!currentUser) {
                navigate("/auth/login");
                setLoading(false);
                return;
            }

            if (!currentUser.emailVerified) {
                await signOut(auth);
                navigate("/auth/login", {
                    state: { error: "Your account is not activated. Please verify your email before continuing. Make sure to check also SPAM folder if you didnt find the validation email." }
                });
                setLoading(false);
                return;
            }

            setUser(currentUser);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [navigate]);

    return { user, loading };
}